module.exports = __webpack_public_path__ + "static/media/Home-PinkWave2.049a2a31.svg";